import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox as AntdCheckbox } from 'antd';

import { View } from '../View';
import Text from '../Text';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const Container = style(View, styles.container);
const SCheckbox = style(AntdCheckbox, styles.checkbox);
const Label = style(Text);
const SublabelContainer = style(View, styles.sublabelContainer);
const Sublabel = style(Text, styles.sublabel);

class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: props.checked
    };
  }

  handleOnChange = ({ target: { checked } }) => {
    const { name, onChange } = this.props;
    this.setState({ checked });
    onChange && onChange(name, checked);
  };

  render() {
    const {
      disabled,
      children,
      name,
      title,
      error,
      sublabel,
      paddingTop,
      paddingBottom
    } = this.props;
    const { checked } = this.state;
    const labelType = title ? 'large' : undefined;
    return (
      <Container paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <SCheckbox
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={this.handleOnChange}
          error={error}
        >
          {children && (
            <Label htmlFor={name} size={labelType}>
              {children}
            </Label>
          )}
        </SCheckbox>
        {sublabel && (
          <SublabelContainer>
            <Sublabel size="small">{sublabel}</Sublabel>
          </SublabelContainer>
        )}
      </Container>
    );
  }
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.bool,
  error: PropTypes.bool,
  sublabel: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  title: false,
  error: false,
  paddingTop: '8px',
  paddingBottom: '8px'
};

export default Checkbox;
